export default "__VITE_ASSET__CfdYUYtR__"